import { computed } from 'vue-demi';

export default (props, request) => {
    /* 自定义股票排行 */
    const isCustomRank = computed(() => props.market_id === 'custom');

    const symbolListStr = computed(() => {
        const symbolList = (props.customStocklist || []).map((stock) => stock.symbol || '');
        return symbolList.filter((item) => !!item.trim()).join(',');
    });

    const stockIdStr = computed(() => {
        const stockIdList = (props.customStocklist || []).map((stock) => stock.stockId || '');
        return stockIdList.filter((item) => !!item.trim()).join(',');
    });

    const getCustomRank = async () => {
        const data = {
            stockIds: stockIdStr.value,
            symbols: symbolListStr.value,
            lang: props.language,
            count: props.count,
            increaseType: props.increaseType,
        };
        try {
            return await request.get('get-custom-rank-list', data);
        } catch (err) {
            console.error('custom-rank', err);
        }
    };

    return {
        isCustomRank,
        getCustomRank
    };
};
